import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import { siderWidth } from '../../../constants/layout'
import { useLocation } from 'react-router-dom';

import statusText from '../../../constants/property';
import CloseButton from '../../layouts/CloseButton';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';
import OpenButton from '../../layouts/OpenButton';
import { contentPadding } from '../../layouts/layoutHelper';
import EStatementTbl from '../../tables/EStatementTbl';
import { FilterProvider } from '../../../context/FilterContext';
import MotionLayout from '../../general/framer-motion/MotionLayout';

import moment from 'moment';

import propertyConstant from '../../../constants/property'


const Index = ({
    
}:any)=>{

    //force refresh when page change
    const location = useLocation();
    const [key, setKey] = useState(location.pathname); // Track the path

    useEffect(() => {
        setKey(location.pathname); // Update key whenever the path changes
    }, [location.pathname]);

    return <div key={key}>
        <MotionLayout>
          
            <EstatementContainer />
           
        </MotionLayout>
    </div>
}
const EstatementContainer = ({  }:any) => {
    const location = useLocation();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [statementType, setStatementType] = useState(null);
    const [title, setTitle] = useState("");

    useLayoutEffect(() => {
        const pathname = location.pathname;
        const lastsegments = pathname.split('/').filter(Boolean);
        let sType = getStatementByUrl("/"+lastsegments);
      
        setStatementType(sType);

        if(sType){
            let statementTypeMap = propertyConstant.statementTypeMap;
            let { label } = statementTypeMap[sType];
            setTitle(label)
        }

    }, []);

    const [accounts, setAccounts] = useState([]);
    const [inputs, setInputs] = useState({});

    const handleSidebarToggle = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    const getStatementByUrl = (url: string): any => {
        let statementTypeMap = propertyConstant.statementTypeMap;
        for (const key in statementTypeMap) {
            if (statementTypeMap[key].url === url) {
                return parseInt(key);
            }
        }
        return undefined; // Return undefined if the URL is not found
    }



    const  generateYearOptions = () => {
        const currentYear = moment().year(); // Get the current year
        let options = [];
    
        // Loop through the last 5 years
        for (let i = 0; i < 5; i++) {
            options.push({
                value: currentYear - i,
                label: currentYear - i
            })
        }
    
        return options;
    }


    const filterColumns = [
        {
            type: "selectUser",
        },
        // {
        //     type:"selectDateRangePicker"
        // },
        // {
        //     type:"selectResearchType",
          
        // }
        {   
            id:"year",
            label:"Year",
            type:"select",
            options:generateYearOptions()
        },
    ]

    
  

    return (
        <FilterProvider>    
            <div className={`page-layout  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                <div className="side-bar" style={{
                    width: isSidebarCollapsed ? '0' : siderWidth
                }}>
                    <CloseButton 
                        handleClick={handleSidebarToggle}
                    />
                    <div className='content' style={{width:siderWidth}}>
                        <div className='pt-3'></div>
                        <FilterInputBuilder 
                            loading={tableLoading}
                            columns={filterColumns} 
                            initSearchWhenReceived={[`accounts[]`]}  
                            onSearchSubmit={(inputs:any)=>{
                                let accounts = inputs['accounts[]'] || [];
                                setAccounts(accounts)
                                //force trigger search
                                setInputs(JSON.parse(JSON.stringify(inputs)));
                            }}
                        />
                    </div>
                
                </div>
                <div className="main-content " style={{
                    marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                    paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                }}>
                    <OpenButton 
                        isSidebarCollapsed={isSidebarCollapsed}
                        handleClick={handleSidebarToggle}
                    />
                    <div className={ contentPadding(isSidebarCollapsed)}>
                        <div>
                            <div className="main-title">{title }</div>  
                            
                            <div className=" col-xxxxl-4 col-xl-4 col-lg-6 col-md-12 col-12">
                            <b className="dark-text-white pb-5">Download PDF</b> 
                            {
                                statementType
                                &&
                                <EStatementTbl statementType={statementType}/>
                            }
                                
                            </div>
                        
                        </div>
                    </div>
                    
                
                </div>
            </div>
        </FilterProvider>
    );
};

export default Index;
